import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { attempt } from 'lodash-es';
import { Hidden, getModifiedProps, provideAxis } from 'react-jsx-highcharts';

var RangeSelectorInner =
/*#__PURE__*/
function (_Component) {
  _inherits(RangeSelectorInner, _Component);

  function RangeSelectorInner(props) {
    var _this;

    _classCallCheck(this, RangeSelectorInner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeSelectorInner).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getRangeSelectorConfig", function () {
      var _this$props = _this.props,
          getHighcharts = _this$props.getHighcharts,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["getHighcharts", "children"]);

      var Highcharts = getHighcharts();
      return _objectSpread({}, Highcharts.defaultOptions && Highcharts.defaultOptions.rangeSelector, rest, {
        inputEnabled: false,
        buttons: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateRangeSelector", function (config) {
      var chart = _this.props.getChart();

      chart.update({
        rangeSelector: config
      }, true);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRangeSelector", function () {
      var _this$props2 = _this.props,
          getChart = _this$props2.getChart,
          getAxis = _this$props2.getAxis;
      var chartObj = getChart().object;
      var axis = getAxis();
      var extremes = axis.getExtremes(); // Fixes #40

      chartObj.rangeSelector.render.call(chartObj.rangeSelector, extremes.min, extremes.max);
    });

    _this.state = {
      rendered: false
    };
    return _this;
  }

  _createClass(RangeSelectorInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          getHighcharts = _this$props3.getHighcharts,
          getChart = _this$props3.getChart,
          getAxis = _this$props3.getAxis; // Workaround inferred from http://jsfiddle.net/x40me94t/2/

      var Highcharts = getHighcharts();
      var chartObj = getChart().object;
      chartObj.options.rangeSelector.enabled = true;
      Highcharts.fireEvent(chartObj, 'init'); // Pre Highcharts 6.1

      Highcharts.fireEvent(chartObj, 'afterGetContainer'); // Highcharts 6.1+

      var opts = this.getRangeSelectorConfig();
      this.updateRangeSelector(opts);
      var axisObj = getAxis().object;
      Highcharts.addEvent(axisObj, 'afterSetExtremes', this.renderRangeSelector);
      this.setState({
        rendered: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var modifiedProps = getModifiedProps(prevProps, this.props);

      if (modifiedProps !== false) {
        this.updateRangeSelector(modifiedProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props4 = this.props,
          getHighcharts = _this$props4.getHighcharts,
          getAxis = _this$props4.getAxis;
      var axisObj = getAxis().object;
      getHighcharts().removeEvent(axisObj, 'afterSetExtremes', this.renderRangeSelector);
      attempt(this.updateRangeSelector, {
        enabled: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      if (!children || !this.state.rendered) return null;
      return React.createElement(Hidden, null, children);
    }
  }]);

  return RangeSelectorInner;
}(Component);

_defineProperty(RangeSelectorInner, "defaultProps", {
  enabled: true
});

export default provideAxis(RangeSelectorInner); // For testing purposes

export var _RangeSelectorInner = RangeSelectorInner;